import { RootState } from "../store/store"
import { isRequiresSelectCompany, LoginStatus } from "./loginTypes"

export function selectLoginStatus({ login }: RootState) {
    return login.status
}

export function selectUsername({ login }: RootState) {
    return login.status === LoginStatus.AUTHENTICATING ? login.username : login.user.username
}

function selectCompanyResponse({ login }: RootState) {
    return login.status === LoginStatus.AUTHENTICATING && login.response && isRequiresSelectCompany(login.response)
        ? login.response.selectCompany
        : undefined
}

export function selectCompanies(state: RootState) {
    return selectCompanyResponse(state)?.companies
}

export function selectIsRequiresSelectCompany(state: RootState) {
    return Boolean(selectCompanyResponse(state))
}

export function selectCompanyReason(state: RootState) {
    return selectCompanyResponse(state)?.reason
}

export function selectCompanyDuplicateValue(state: RootState) {
    return selectCompanyResponse(state)?.duplicateValue
}

export function selectRememberMe({ login }: RootState) {
    return login.status === LoginStatus.AUTHENTICATING ? login.rememberMe : undefined
}

export function selectAuthToken({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? login.authToken : undefined
}

export function selectUserType({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? login.user.userType : undefined
}

export function selectUserInitials({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? login.user.displayInitials : undefined
}

export function selectUserCompanyId({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? login.user.companyId : undefined
}

export function selectUserGroupId({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? login.user.userGroupId : undefined
}

export function selectAuthenticatedUser({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? login.user : undefined
}

export function selectUserId({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? login.user.id : undefined
}

/** True for a DEVICE_SECRET session, whose stand-in user has no administrator behind it. */
export function selectIsDeviceSession({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? Boolean(login.user.isDeviceSession) : false
}

/** The merchant uid a DEVICE_SECRET session carries, absent on regular admin sessions. */
export function selectMerchantUid({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? login.user.merchantUid : undefined
}

export function selectServiceCenterId({ login }: RootState) {
    return login.status === LoginStatus.LOGGED_IN ? login?.user?.serviceCenterId : undefined
}
